import React, { useState, useEffect } from 'react';
import { API_URL, secret_key, storedData } from '../Constants';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import CryptoJS from "crypto-js";
import Papa from 'papaparse';
import loading1 from "../../assets/loading.gif"
import InfiniteScroll from 'react-infinite-scroll-component';

function ImportLines() {
  const { id } = useParams();
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
  const [message_data, setMessageData] = useState({});
  const [message_groups, setMessageGroups] = useState('');

  const queryParams = new URLSearchParams(window.location.search);
  const smsStatus = queryParams.get('sms_status');
  
  const [searchTerm, setSearchTerm] = useState('');
  const [generaldata, setGeneraldata] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
  }
  
  const [companydata, setcompanydata] = useState("");
  let navigate = useNavigate();

  useEffect(() => {
    const fetchNewMessage = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_message_id/${id}`, {
          headers: {
            Authorization: token,
          },
        });
        const message = response.data;
        setMessageData(message);
        setMessageGroups(message.group_id);
      } catch (error) {
        if (error?.response?.status === 401) {
          navigate(0);
        }
      }
    };

    fetchNewMessage();
  }, [id, token]);

  const fetchMessageForId = () => {
      let url = `${API_URL}/get_message_line_id_v1/${id}?page=${page}&limit=${50}`;
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      };
      axios
      .request(config)
      .then(response => {
        // setGeneraldata(response.data);
        // setLoading(false);
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setGeneraldata([...generaldata, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(()=>{
    fetchMessageForId();
  }, [id, token])

   //Get company data
   const fetchCompanyByID = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_company/${logeduserData?.company_id}`,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      setcompanydata(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  };

  const loadMoreMessages = () => {
    fetchMessageForId();
  }

  useEffect(() => {
    fetchCompanyByID();
  }, []);

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };


  const messageGroup = message_data.group_id

  //upload csv
  const [data, setData] = useState([]);
  const handleFileUpload = (e) => {
    const file = e?.target?.files[0];
    Papa.parse(file, {
      header: false,
      skipEmptyLines: true,
      complete: (results) => {
        const parsedData = results.data.slice(1)
        .map((item) => ({ 
          PhoneNo: item[0],
          Message: item[1],  
          message_id: id,
          rate: companydata.rate,
          company_id: logeduserData?.company_id,  
        }));
        setData(parsedData);
        insertMessageLines(parsedData);
      },
    });
    
  };

  const filteredtxt = generaldata.filter((recipient) => {
    const { phone_no, message_body } = recipient;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return( 
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) ||
      message_body.toLowerCase().includes(lowerCaseSearchTerm)
    );

  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const insertMessageLines = (formDta) => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    const url = `${API_URL}/post_import_messageLines`;
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data: formDta,
    };

    axios.request(config)
    .then((response) => { 
      setIsSubmitting(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Lines loaded",
      })
      .then(() => {
        navigate(0);
      })
    })
    .catch ((error) => {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error?.response?.data?.error,
      })
    })
  }

  const insertGeneral = () => {   
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let sendGeneralData = generaldata.map((data) => ({
      phone_no: data.phone_no,
      message_body: data.message_body,
      message_subject: message_data.message_subject,
      message_id: id,
      company_id: logeduserData?.company_id,
      sender_id: logeduserData?.sender_id,
      sms_provider: logeduserData?.sms_provider,
      rate: companydata.rate,
    }));

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/postGeneralSMS`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        data: sendGeneralData,
      };

      axios
        .request(config)
        .then(() => {
          setIsSubmitting(false);
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Message sent successfully',
          })
          .then(() => {
            navigate("/recent_sms");
          })
        })
        .catch(() => {
          setIsSubmitting(false);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Message failed',
          });
        });
  };  

  const clearImportedLines = () => {
    if (isSubmitting) {
      return;
    }
  
    Swal.fire({
      title: 'Are you sure you want to clear?',
      text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      setIsSubmitting(true);
      if (result.isConfirmed) {
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/deleteMessageLinesById/${id}/${logeduserData?.company_id}`,
          headers: {
            'Authorization': token
          }
        };
        
        axios.request(config)
        .then((response) => {
          setTimeout(() => {
            setIsSubmitting(false);
            Swal.fire({
              title: 'Deleted!',
              text: 'The lines have been deleted.',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              showConfirmButton: false
            })
            .then(() => {
              navigate(0);
            });
          }, 1000);
        })
        .catch((error) => {
          setIsSubmitting(false);
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: error?.response?.data?.error,
          })
        });
      }
    });
  }

  return (
    <div style={{marginTop: '60px'}}>
      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary card-outline">
                  <div className="card-header">
                    <div className='row'>
                    <div className=''>
                      <h3 className="card-title">Subject: {message_data.message_subject}</h3>
                      <div className=' float-right '>
                        {message_data?.status == 0 ? (<div  >
                        {message_data?.status == 1 ? "" : (<button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Options
                          <span className="caret" /></button>)}
                        <ul className= "dropdown-menu companyActions">
                          { generaldata.length > 0 ? (<li onClick={insertGeneral}><i className="fa fa-paper-plane"></i>
                            Send SMS
                          </li>):
                         ( <li onClick={() => document.getElementById('file-input').click()}><i className="fa fa-upload"></i>
                            Import lines
                            <input
                              id="file-input"
                              type="file"
                              accept=".csv"
                              onChange={handleFileUpload}
                              style={{ display: 'none' }}
                            />
                          </li>)}
                          <li><i className="fa fa-download"></i>
                              <a
                                  href="/files/Sms.csv"
                                  className="download-link"
                                  download
                              >
                                  Download template
                              </a>
                          </li>
                    
                          { generaldata.length > 0 ? (<li onClick={clearImportedLines}><i className="fa fa-trash"></i>
                            Clear lines
                          </li>) : ""}
                        </ul>
                      </div>): ""}
                    </div>
                    </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="form-group">Message: {message_data.message_body}</div>
                    {messageGroup ? (<div className="form-group">Groups: {message_data.group_id}</div>):""}
                    <div className="form-group">Total Lines: {message_data.total_count}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

      
        <InfiniteScroll

            dataLength={filteredtxt.length}
            next={loadMoreMessages}
            hasMore={hasMore}
            loader={filteredtxt.length > 0 ? null : 
            <div className="loadingsubcontainer">
            <img className="loadingsubimg" src={loading1} alt="" />
            </div>}
            endMessage={<p>No more messages to load.</p>}
        >
         <table id="example" className="table table-striped">
          <thead>
            <tr>
              <th>Phone No</th>
              <th>Recipient</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {filteredtxt.map((recipient, id) => (
              <tr key={id}>
                <td>{recipient.phone_no}</td>
                <td>{recipient.contact_name}</td>
                <td>{recipient.message_body}</td>
              </tr>
            ))}
          </tbody>
        </table>
        </InfiniteScroll>
       
    </div>
  );
}

export default ImportLines;
